import React from "react";
import { twMerge } from "tailwind-merge";

interface BudgetEtfHeaderProps {
  header: string;
  description?: string;
  customClass?: string;
}

const BudgetEtfHeader = ({
  header,
  description,
  customClass,
}: BudgetEtfHeaderProps) => (
  <div className={twMerge("flex flex-col gap-2", customClass)}>
    <h2 className="text-[18px] font-medium text-primary-text md:text-[20px]">
      {header}
    </h2>
    {description ? (
      <p className="text-[12px] leading-[16px] text-gray-600 lg:text-gray-900">
        {description}
      </p>
    ) : null}
  </div>
);
export default BudgetEtfHeader;
